import { render, staticRenderFns } from "./product-params.vue?vue&type=template&id=0c64669a&scoped=true&"
import script from "./product-params.vue?vue&type=script&lang=js&"
export * from "./product-params.vue?vue&type=script&lang=js&"
import style0 from "./product-params.vue?vue&type=style&index=0&id=0c64669a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c64669a",
  null
  
)

export default component.exports